import { type DiscussionsLinkedTypes } from "types/enum";

import { APIHandler, PreviewActionAPIError } from "utilities/apiHandler";

import {
    DiscussionsEntity,
    EntitiesResponse,
    ParticipantsResponse,
} from "./DiscussionContainer.api.types";

export interface IDiscussionsHandler {
    get(
        builderId: number,
        linkedType: DiscussionsLinkedTypes,
        linkedId: number,
        jobId?: number,
    ): Promise<DiscussionsEntity>;
    participants(linkedId: number, linkedType: number): Promise<ParticipantsResponse>;
    getEntities(entityType: number, jobId: number): Promise<EntitiesResponse>;
}

export class DiscussionsHandler implements IDiscussionsHandler {
    async get(
        builderId: number,
        linkedType: DiscussionsLinkedTypes,
        linkedId: number,
        jobId?: number,
    ): Promise<DiscussionsEntity> {
        const request: any = {
            builderID: builderId,
            linkedId: linkedId,
            linkedType: linkedType,
            jobId: jobId,
            reverseOrder: false,
        };

        return await APIHandler("/api/discussions", {
            method: "GET",
            data: request,
            responseType: DiscussionsEntity,
        });
    }

    async participants(linkedId: number, linkedType: number): Promise<ParticipantsResponse> {
        const request: any = {
            linkedId: linkedId,
            linkedType: linkedType,
        };

        return await APIHandler("/api/discussions/commentparticipants", {
            method: "GET",
            data: request,
            responseType: ParticipantsResponse,
        });
    }

    async getEntities(entityType: number, jobId: number): Promise<EntitiesResponse> {
        return await APIHandler("/api/discussions/Entities", {
            method: "GET",
            data: { entityType, jobId },
            responseType: EntitiesResponse,
        });
    }
}

export class InlinePreviewDiscussionsHandler implements IDiscussionsHandler {
    async get(): Promise<DiscussionsEntity> {
        throw new PreviewActionAPIError();
    }

    async participants(): Promise<ParticipantsResponse> {
        throw new PreviewActionAPIError();
    }

    async getEntities(): Promise<EntitiesResponse> {
        throw new PreviewActionAPIError();
    }
}

export const defaultDiscussionsHandler = new DiscussionsHandler();
